module.exports = __webpack_public_path__ + "img/blog-55 (1).ecf6fee1.jpg";